import { gql } from "@apollo/client"

export const DELETE_TOURNAMENT_ORGANIZER = gql`
  mutation deleteTournamentOrganizer($id: Int!) {
    deleteTournamentOrganizer(id: $id) {
      id
    }
  }
`
